import FormInputRowConfig from "./FormInputRowConfig";
import FormRowState from "./FormRowState";
import FormInputRowModeTypesToGroupMap from "./FormInputRowModeTypesToGroupMap";
import dayjs from "dayjs";
import { Dayjs } from "dayjs";
import { Form } from "react-router-dom";

function FormInputRowIsValid(rowState: FormRowState, modes: FormInputRowConfig): boolean {
  const currentVariant = modes.inputOptions[rowState.currentModeIndex].optionVariant;
  const currentModeState = rowState.currentModeStates[rowState.currentModeIndex];
  const currentMode = modes.inputOptions[rowState.currentModeIndex];

  const isOptional = modes.isOptionalParameter === true;

  if (modes.invalidIfEdited && rowState.originalRowState !== undefined) {
    return false;
  }

  if (FormInputRowModeTypesToGroupMap.numberModes.includes(currentVariant)) {
    if (currentModeState === null) {
      return isOptional; // only apply optional if null, else enforce bounds checking
    }

    if (currentMode.numberMin !== undefined && currentMode.numberMin !== null) {
      if (currentMode.numberMinMaxEndpointExclusive) {
        if ((currentModeState as number) <= currentMode.numberMin) {
          return false;
        }
      } else if ((currentModeState as number) < currentMode.numberMin) {
        return false;
      }
    }

    if (currentMode.numberMax !== undefined && currentMode.numberMax !== null) {
      if (currentMode.numberMinMaxEndpointExclusive) {
        if ((currentModeState as number) >= currentMode.numberMax) {
          return false;
        }
      } else if ((currentModeState as number) > currentMode.numberMax) {
        return false;
      }
    }
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.singleDateModes.includes(currentVariant)) {
    if (currentModeState === null) {
      return isOptional; // only apply optional if null, else enforce bounds checking
    }

    if (currentMode.dateMin !== undefined && currentMode.dateMin !== null) {
      if (currentMode.dateMinMaxEndpointExclusive) {
        if (!dayjs(currentModeState as Dayjs).isAfter(dayjs(currentMode.dateMin), "day")) {
          return false;
        }
      } else if (dayjs(currentModeState as Dayjs).isBefore(dayjs(currentMode.dateMin), "day")) {
        return false;
      }
    }

    if (currentMode.dateMax !== undefined && currentMode.dateMax !== null) {
      if (currentMode.dateMinMaxEndpointExclusive) {
        if (!dayjs(currentModeState as Dayjs).isBefore(dayjs(currentMode.dateMax), "day")) {
          return false;
        }
      } else if (dayjs(currentModeState as Dayjs).isAfter(dayjs(currentMode.dateMax), "day")) {
        return false;
      }
    }

    return true;
  }

  if (FormInputRowModeTypesToGroupMap.fixedModes.includes(currentVariant)) {
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.stringModes.includes(currentVariant)) {
    if (currentModeState === null || currentModeState === "") {
      return isOptional;
    }
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.symbolModes.includes(currentVariant)) {
    if (currentModeState === null || currentModeState === "") {
      return isOptional;
    }
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.selectModes.includes(currentVariant)) {
    if (currentModeState === null || currentModeState === "") {
      return isOptional;
    }
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.booleanModes.includes(currentVariant)) {
    if (currentMode.mandatoryCheckboxOrSwitch) {
      return currentModeState === true;
    }
    return true;
  }

  if (FormInputRowModeTypesToGroupMap.formModes.includes(currentVariant)) {
    if (currentModeState === null) {
      return isOptional;
    }
    if (!(currentModeState instanceof Array)) {
      return false;
    }

    return currentModeState.every((formRowState, index) => {
      const nestedFormConfig = modes.inputOptions[rowState.currentModeIndex].nestedFormConfig;
      return nestedFormConfig === undefined
        ? false
        : FormInputRowIsValid(formRowState, nestedFormConfig.formConfig[index]);
    });
  }

  if (FormInputRowModeTypesToGroupMap.refreshModes.includes(currentVariant)) {
    return true;
  }

  return false; // this should never be reached
}

export default FormInputRowIsValid;
